/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { memo } from 'react'
import colors from '@sportninja/common/constants/appColors'
import { paragraphSmall, weightMedium, weightRegular } from '../css'

interface AddCommentProps {
  userAvatarUrl?: string
  onCommentClick?: () => void
}

const containerStyles = css`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: outline-color 0.2s ease;
`

const avatarStyles = css`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid ${colors.WHITE};
  object-fit: contain;
`

const inputContainerStyles = css`
  height: 40px;
  flex: 1;
  padding: 8px 16px;
  background: ${colors.SECONDARY_200};
  border-radius: 8px;
  border: 1px solid ${colors.SECONDARY_100};
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const placeholderTextStyles = css`
  ${paragraphSmall}
  ${weightRegular}
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: ${colors.NEUTRAL_50};
`

const postButtonStyles = css`
  ${paragraphSmall}
  ${weightMedium}
  color: ${colors.SECONDARY_100};
`

const PLACEHOLDER_USER_IMAGE =
  '/images/generic_placeholders/placeholder_player.png'

/**
 * AddComment component renders a clickable comment input field with user avatar
 */
const AddComment: React.FC<AddCommentProps> = ({
  userAvatarUrl,
  onCommentClick,
}) => {
  const avatarSrc = userAvatarUrl || PLACEHOLDER_USER_IMAGE

  return (
    <div css={containerStyles} onClick={onCommentClick}>
      <img src={avatarSrc} alt='User avatar' css={avatarStyles} />
      <div css={inputContainerStyles}>
        <div css={placeholderTextStyles}>Add a comment</div>
        <div css={postButtonStyles}>Post</div>
      </div>
    </div>
  )
}

export default memo(AddComment)
